// src/systems/saveSystem.ts — Abstracción de guardado (local + futuro D1)
import { store } from '../app/state.js';
import { hasSave, saveRemote } from '../app/storage.js';

export const SaveSystem = {
  hasSave,
  getState: () => store.get(),
  newGame(name: string) {
    store.reset(name);
  },
  async syncToCloud(): Promise<{ ok: boolean; error?: string }> {
    return saveRemote(store.get());
  }
};
